import { Button, Css, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { useState } from "react";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { DimensionTypeCheckboxes } from "src/routes/bids/plan-based-bid-package/components/DimensionTypeCheckboxes";
import { buildDimensions, PlanBasedBidPackageBidPlanGroup } from "src/routes/bids/plan-based-bid-package/utils";

type BasePlanPriceDimensionsModalProps = {
  group: ObjectState<PlanBasedBidPackageBidPlanGroup>;
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
};

export function BasePlanPriceDimensionsModal(props: BasePlanPriceDimensionsModalProps) {
  const { group, dimensionResults } = props;
  const { closeModal } = useModal();
  const [selectedTypeIds, setSelectedTypeIds] = useState<string[]>(
    (group.dimensions.value ?? []).map((d) => d.globalOptionTypeId).filter((id): id is string => !!id),
  );

  return (
    <>
      <ModalHeader>Base Plan Price Dimensions</ModalHeader>
      <ModalBody>
        <div css={Css.mb3.$}>Define the attributes to include as lines in your bid sheet.</div>
        <DimensionTypeCheckboxes
          dimensionResults={dimensionResults}
          selectedTypeIds={selectedTypeIds}
          onChange={setSelectedTypeIds}
        />
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="tertiary" onClick={closeModal} />
        <Button
          label="Save"
          onClick={() => {
            group.dimensions.set(buildDimensions(selectedTypeIds, group.dimensions.value ?? [], dimensionResults));
            closeModal();
          }}
        />
      </ModalFooter>
    </>
  );
}
